export default __webpack_public_path__ + "static/media/newrelic.028196da.svg";